import * as React from 'react';

import { PrimaryCta } from 'components/Buttons';

import {
  NotificationModal,
  useOpenNotificationModal
} from 'catering/components/Modals';

function LeadTimesChangedNotification() {
  const handlePrimaryCtaClick = () => {
    window.location.reload();
  };

  return (
    <NotificationModal
      title="Uh oh! This item is not available at this time."
      text="Please refresh the page and update your fulfillment time to add this to your cart."
    >
      <PrimaryCta
        label="Refresh"
        handleClick={handlePrimaryCtaClick}
        fullWidth
      />
    </NotificationModal>
  );
}

export function useOpenLeadTimesChangedNotificationModal() {
  return useOpenNotificationModal(<LeadTimesChangedNotification />);
}
